import React from 'react';
import { Image, Linking, Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { useDialog } from '@/hooks/useDialog';
import constants from '@/config/constants';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';
import { styles } from './Footer.styles';
import { Links } from '@/config/links';

export function Footer() {
  const { showDialog } = useDialog();
  return (
    <View style={styles.container}>
      <View>
        <View style={styles.logoWrapper}>
          <Image
            style={styles.logo}
            resizeMode="contain"
            source={require('@/assets/ce4.png')}
          />
        </View>
        <Text>App Version {constants.appVersion}</Text>
        <Text>UDI-DI {constants.udiDi}</Text>
        {/* This nested Text solves a bug where the UDI-PI value is not displayed in the footer.
          The reason for this is currently unknown and needs to be investigated further.
          Other external devs seem to have a similar issue https://github.com/facebook/react-native/issues/21729
        */}
        <Text>
          UDI-PI <Text>{constants.udiPi()}</Text>
        </Text>
      </View>
      <View style={styles.linkRow}>
        <Pressable onPress={() => Linking.openURL(Links.impressum.href)}>
          <Text style={styles.linkText}>Impressum</Text>
        </Pressable>
        <Pressable onPress={() => Linking.openURL(Links.datenschutz.href)}>
          <Text style={styles.linkText}>Datenschutz</Text>
        </Pressable>
        <Pressable onPress={() => showDialog(PREPARED_DIALOGS.kontaktDialog())}>
          <Text style={styles.linkText}>Kontakt</Text>
        </Pressable>
      </View>
    </View>
  );
}
